import type { Translation } from '../types.ts';
import type en from '../en/snelstart.ts';

export default {
    title: 'SnelStart',
    intro: 'Facturen en creditfacturen van {website} worden geboekt in de SnelStart-administratie.',
    noWebsite: 'Kies eerst een website om de SnelStart-koppeling ervan te beheren.',
    saved: 'SnelStart-instellingen opgeslagen.',
    platform: {
        title: 'SnelStart is op dit platform nog niet ingesteld.',
        body: 'Het platform heeft eerst een SnelStart-abonnementssleutel nodig voordat er iets geboekt kan worden. De koppelsleutel en de opties kun je al wel invullen.',
    },
    connection: {
        title: 'Koppeling',
        intro: 'Maak in SnelStart Web onder Koppelingen een koppelsleutel voor deze administratie, plak hem hier en sla op. Met Verbinding testen worden daarna de grootboekrekeningen gelezen.',
        clientKey: 'Koppelsleutel',
        clientKeySet: 'Ingesteld: typ een nieuwe om hem te vervangen',
        clientKeyHint: 'Wordt versleuteld opgeslagen en niet meer getoond.',
        test: 'Verbinding testen',
        testOk: 'Verbonden: {count} grootboekrekeningen gelezen.',
        lastTestOk: 'Laatste test {date}: verbonden.',
        lastTestFailed: 'Laatste test {date} mislukt: {error}',
    },
    ledgers: {
        title: 'Grootboekrekeningen',
        intro: 'Op welke grootboekrekening elke soort omzet wordt geboekt. Per btw-tarief komt één regel op de rekening die je hier kiest.',
        none: 'Niet hier boeken',
        reload: 'Rekeningen opnieuw laden',
        notLoaded: 'Test de verbinding om de grootboekrekeningen van de administratie te laden.',
        requiredNote: '* nodig voordat de koppeling aan kan. De andere alleen als de winkel zulke verkopen doet.',
    },
    categories: {
        high: 'Omzet hoog (21%)',
        low: 'Omzet laag (9%)',
        zero: '0% of vrijgesteld',
        intra_eu: 'Leveringen binnen de EU (ICP)',
        export: 'Export buiten de EU',
        oss: 'OSS-afstandsverkopen',
        out_of_scope: 'Verkochte cadeaubonnen',
        shipping: 'Verzendkosten (optioneel, anders in de omzet)',
    },
    options: {
        title: 'Opties',
        attachPdf: 'Factuur-pdf bijvoegen',
        attachPdfHint: 'De pdf die de klant krijgt wordt in SnelStart bij de boeking gezet.',
        bookFrom: 'Facturen boeken vanaf',
        bookFromHint: 'Eerdere facturen blijven ongemoeid. Wordt ingevuld als de koppeling voor het eerst aangaat.',
    },
    enabled: {
        title: 'Boeken',
        label: 'Uitgegeven facturen boeken in SnelStart',
        hintOn: 'Elke factuur en creditfactuur wordt kort na het aanmaken geboekt.',
        hintOff: 'Zolang dit uit staat wordt er niets geboekt.',
        on: 'Boeken in SnelStart staat aan.',
        off: 'Boeken in SnelStart staat uit.',
        missing: 'Kies een grootboekrekening voor: {categories}.',
    },
    bookings: {
        title: 'Boekingen',
        allStatuses: 'Alle statussen',
        status: 'Status',
        invoice: 'Factuur',
        typeInvoice: 'Factuur',
        creditNote: 'Creditfactuur',
        issued: 'Datum',
        customer: 'Klant',
        amount: 'Bedrag',
        bookedAt: 'Geboekt {date}',
        sendAgain: 'Opnieuw versturen',
        sendUnbooked: 'Boek {n} ongeboekte factuur | Boek {n} ongeboekte facturen',
        queued: 'Factuur {number} staat klaar voor SnelStart.',
        queuedAll: 'Geen facturen klaargezet. | 1 factuur staat klaar voor SnelStart. | {n} facturen staan klaar voor SnelStart.',
        empty: 'Nog geen boekingen.',
    },
    status: {
        booked: 'Geboekt',
        failed: 'Mislukt',
        pending: 'Wacht',
        skipped: 'Overgeslagen',
    },
} satisfies Translation<typeof en>;
